import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import clone from 'just-clone'
import { Serializer } from '@niknevis/serializer'

@Component
export class SerializerMixin<T extends Serializer<any>> extends Vue {
  protected queryModel(): any {
    throw new Error('must override queryModel')
  }

  protected model!: T

  data() {
    return {
      model: null
    }
  }

  protected queryChanged(): any {
  }

  protected beforeFill(): any {
  }

  protected afterFill(): any {
  }

  created() {
    if (this.model === null) {
      throw new Error('must override model')
    }

    this.$watch(
      () => this.queryModel(),
      (n) => {
        this.queryChanged()
        this.beforeFill()
        this.model.$fill(clone<any>(n))
        this.afterFill()
      },
      {
        immediate: true,
        deep: true
      }
    )
  }
}

